import createField from '../../utils/factory/createField';
import { faLayerGroup } from '@fortawesome/free-solid-svg-icons';

export const kitFields = [
    {
        section: 'Informações do Kit',
        fields: [
            createField({
                id: 'kit.name',
                label: 'Kit',
                type: 'text',
                placeholder: 'Digite o nome do kit',
                fullWidth: true,
                icon: faLayerGroup,
            }),
        ],
    },
];

export const kitItemFields = [
    {
        section: 'Informações do Kit Item',
        fields: [
            createField({
                id: 'kitItem.name',
                label: 'Kit Item',
                type: 'text',
                placeholder: 'Digite o nome do item do kit',
                fullWidth: true,
                icon: faLayerGroup,
            }),
        ],
    },
];
